"use client";

import type { FC } from "react";
import { CollapseIcon, ExpandIcon } from "../../vectors";
import { Button } from "../Button/Button";
import { Tooltip } from "../Tooltip/Tooltip";

export interface ExpandCollapseToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
  /** Tooltip + accessible label when expanded. Defaults to "Collapse". */
  collapseLabel?: string;
  /** Tooltip + accessible label when collapsed. Defaults to "Expand". */
  expandLabel?: string;
  variant?: "light" | "bordered";
}

/** Icon button that toggles between expand/collapse states with a tooltip. */
export const ExpandCollapseToggle: FC<ExpandCollapseToggleProps> = ({
  isExpanded,
  onToggle,
  collapseLabel = "Collapse",
  expandLabel = "Expand",
  variant = "light",
}) => {
  const label = isExpanded ? collapseLabel : expandLabel;
  return (
    <Tooltip content={label} color="foreground">
      <Button
        isIconOnly
        variant={variant}
        size="sm"
        onPress={onToggle}
        aria-label={label}
        className={variant === "bordered" ? "min-w-10" : undefined}
      >
        {isExpanded ? (
          <CollapseIcon className="size-5 text-icon-neutral-onMatch-usual" />
        ) : (
          <ExpandIcon className="size-5 text-icon-neutral-onMatch-usual" />
        )}
      </Button>
    </Tooltip>
  );
};
